import React, { useEffect, useState } from "react";
import "./Contact.css";
import AOS from "aos";
import "aos/dist/aos.css";

import {
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaGlobe,
} from "react-icons/fa";

export default function Contact() {
  const [branch, setBranch] = useState("karmanghat");
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    classApplying: "",
    message: ""
  });

  useEffect(() => {
    AOS.refresh();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    const { fullName, email, phone, classApplying, message } = formData;
    const whatsappNumber = branch === "karmanghat" ? "9553763144" : "9553741544";
    
    // Construct beautifully formatted message text (completely without emoji icons to prevent diamond symbols)
    const formattedText = `*New Contact Enquiry*\n\n` +
      `*Name:* ${fullName}\n` +
      `*Email:* ${email}\n` +
      `*Phone:* ${phone}\n` +
      `*Branch:* ${branch === "karmanghat" ? "Karmanghat" : "Saroor Nagar"}\n` +
      `*Class Applying For:* ${classApplying}\n` +
      `*Message:* ${message || "N/A"}`;
      
    const encodedText = encodeURIComponent(formattedText);
    const whatsappUrl = `https://wa.me/91${whatsappNumber}?text=${encodedText}`;
    
    window.open(whatsappUrl, "_blank");
    
    // Reset form
    setFormData({
      fullName: "",
      email: "",
      phone: "",
      classApplying: "",
      message: ""
    });
  };

  return (
    <div className="contact-page">
      {/* HEADER */}
      <div className="contact-header">
        <h1>Contact Us</h1>
        <p>
          Reach out to our team for admission queries and guidance.
        </p>
      </div>

      {/* BRANCH SWITCH */}
      <div className="branch-tabs">
        <button
          className={branch === "karmanghat" ? "active" : ""}
          onClick={() => setBranch("karmanghat")}
        >
          Karmanghat Branch
        </button>

        <button
          className={branch === "saroornagar" ? "active" : ""}
          onClick={() => setBranch("saroornagar")}
        >
          Saroor Nagar Branch
        </button>
      </div>

      {/* MAIN */}
      <div className="contact-container">
        {/* FORM */}
        <div className="contact-form" data-aos="fade-right">
          <h2>
            {branch === "karmanghat"
              ? "Karmanghat Enquiry"
              : "Saroor Nagar Enquiry"}
          </h2>

          <form onSubmit={handleContactSubmit}>
            <input 
              type="text" 
              name="fullName"
              placeholder="Full Name" 
              value={formData.fullName}
              onChange={handleInputChange}
              required 
            />
            <input 
              type="email" 
              name="email"
              placeholder="Email Address" 
              value={formData.email}
              onChange={handleInputChange}
              required 
            />
            <input 
              type="tel" 
              name="phone"
              placeholder="Phone Number" 
              value={formData.phone}
              onChange={handleInputChange}
              required 
            />

            <input
              type="text"
              name="classApplying"
              placeholder="Class Applying For"
              value={formData.classApplying}
              onChange={handleInputChange}
              required
            />

            <input
              type="text"
              value={
                branch === "karmanghat"
                  ? "Karmanghat Branch"
                  : "Saroor Nagar Branch"
              }
              readOnly
            />

            <textarea 
              name="message"
              placeholder="Your Message" 
              rows="5"
              value={formData.message}
              onChange={handleInputChange}
            ></textarea>

            <button type="submit">Submit Enquiry</button>
          </form>
        </div>

        {/* INFO */}
        <div className="contact-info">
          {/* CONTACT CARD */}
          <div className="info-card" data-aos="fade-left">
            <FaPhoneAlt className="info-icon" />
            <h3>Contact</h3>

            {branch === "karmanghat" ? (
              <>
                <p><strong>Phone:</strong> +91 9553763144</p>
                <p><strong>Email:</strong> lotuslap_school_krgt@ymail.com</p>
                <p><strong>Timings:</strong> 8:00 AM - 5:30 PM</p>
              </>
            ) : (
              <>
                <p><strong>Phone:</strong> +91 9553741544</p>
                <p><strong>Email:</strong> lotuslap_school_kpt@ymail.com</p>
                <p><strong>Timings:</strong> 8:00 AM - 5:30 PM</p>
              </>
            )}
          </div>

          {/* ADDRESS CARD */}
          <div className="info-card" data-aos="fade-left">
            <FaMapMarkerAlt className="info-icon" />
            <h3>Visit Us</h3>

            {branch === "karmanghat" ? (
              <p>Mandamallamma Branch, Karmanghat, Hyderabad</p>
            ) : (
              <p>Saroornagar, HUDA Complex, Kothapet, Hyderabad</p>
            )}
          </div>

          {/* SOCIAL CARD */}
          <div className="info-card" data-aos="fade-left">
            <FaGlobe className="info-icon" />
            <h3>Connect With Us</h3>

            <div className="social-icons">
              {branch === "karmanghat" ? (
                <>
                  <a
                    href="https://www.facebook.com/lotus.karmanghat"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaFacebookF />
                  </a>

                  <a
                    href="https://www.instagram.com/lotuslapschoolkharmanghat?igsh=MTVpY2syanRkZHgwYQ%3D%3D"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaInstagram />
                  </a>

                  
                </>
              ) : (
                <>
                  <a
                    href="https://www.facebook.com/lotus.karmanghat"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaFacebookF />
                  </a>

                  <a
                    href="https://www.instagram.com/lotuslap_srnr?igsh=MWRlemNuYzQ4OHEzZg=="
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaInstagram />
                  </a>

                  
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}